// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mt-1";
export var stateContainer = "_mt-0";